import { useTranslation } from "react-i18next";
import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { Input } from "components/ui/input";

interface InputModeProps {
  onSave: (keyword: string) => void | Promise<void>;
  onCancel: (keyword: string) => void;
}

const InputMode = ({ onSave, onCancel }: InputModeProps) => {
  const { t } = useTranslation(["components", "general"]);
  const [newKeyword, setNewKeyword] = useState("");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setNewKeyword(event.target.value);
  };

  const submit = useCallback(
    async (keyword: string) => {
      const trimmed = keyword.trim();
      if (trimmed) {
        await onSave(trimmed);
      }
      setNewKeyword("");
    },
    [onSave],
  );

  const handleKeypress = useCallback(
    async (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        await submit(newKeyword);
      }
      if (event.key === "Escape") {
        onCancel(newKeyword);
      }
    },
    [submit, newKeyword, onCancel],
  );

  const handleBlur = useCallback(async () => {
    await submit(newKeyword);
  }, [submit, newKeyword]);

  return (
    <div className="w-full min-h-14 flex items-center py-2 px-4 border-secondary-200 border">
      <Input
        value={newKeyword}
        placeholder={t(
          "components:keywordsTab.finalKeywords.input.placeholder",
        )}
        onChange={handleChange}
        onKeyDown={handleKeypress}
        onBlur={handleBlur}
        autoFocus
      />
    </div>
  );
};

export default InputMode;
